__turbopack_context__.v({
  "applyButton": "Pkcbtq_applyButton",
  "bottom": "Pkcbtq_bottom",
  "break": "Pkcbtq_break",
  "buttons": "Pkcbtq_buttons",
  "content": "Pkcbtq_content",
  "dot": "Pkcbtq_dot",
  "footer": "Pkcbtq_footer",
  "footerButtons": "Pkcbtq_footerButtons",
  "footerLink": "Pkcbtq_footerLink",
  "headline": "Pkcbtq_headline",
  "headlineBody": "Pkcbtq_headlineBody",
  "headlineTitle": "Pkcbtq_headlineTitle",
  "heroSection": "Pkcbtq_heroSection",
  "infoLink": "Pkcbtq_infoLink",
  "infoText": "Pkcbtq_infoText",
  "label": "Pkcbtq_label",
  "labelText": "Pkcbtq_labelText",
  "linkButton": "Pkcbtq_linkButton",
  "links": "Pkcbtq_links",
  "logoText": "Pkcbtq_logoText",
  "logos": "Pkcbtq_logos",
  "logosAndButton": "Pkcbtq_logosAndButton",
  "logosButtonContainer": "Pkcbtq_logosButtonContainer",
  "overline": "Pkcbtq_overline",
  "overlineText": "Pkcbtq_overlineText",
  "partnersLink": "Pkcbtq_partnersLink",
  "partnersSection": "Pkcbtq_partnersSection",
  "root": "Pkcbtq_root",
  "section1": "Pkcbtq_section1",
  "section2": "Pkcbtq_section2",
  "sectionFaq": "Pkcbtq_sectionFaq",
  "sectionPartners": "Pkcbtq_sectionPartners",
  "subtitle": "Pkcbtq_subtitle",
  "title": "Pkcbtq_title",
});
